<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2"
       stroke-linecap="round" stroke-linejoin="round" class="custom-search-icon">
    <circle cx="9" cy="9" r="5"/>
    <path d="M12.5 12.5l3.5 3.5"/>
  </svg>
</template>

<script>
export default {
  name: 'SearchIcon',
}
</script>

<style scoped>
.custom-search-icon {
  width: 18px;
  height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchIcon.vue